import React from "react";

const PanelSubHeading = (props: { text: string}) => {

    return(
        <div className="panelHeading">
            <h2>{props.text}</h2>
        </div>
    )
}

export default PanelSubHeading;